import React from "react";

interface NavbarContextState {
    rolledDown: boolean;
    opaque: boolean;
    setOpaque: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NavbarContext = React.createContext<NavbarContextState>({
    rolledDown: false,
    opaque: false,
    setOpaque: () => {},
});

export default NavbarContext;

export const NavbarContextWrapper: React.FC<React.PropsWithChildren> = (props) => {
    const [rolledDown, setRolledDown] = React.useState(false);
    const [opaque, setOpaque] = React.useState(false);

    React.useEffect(() => {
        setRolledDown(true);
    }, []);

    return (
        <NavbarContext.Provider
            value={{
                rolledDown,
                opaque,
                setOpaque,
            }}
        >
            {props.children}
        </NavbarContext.Provider>
    );
};
